// extracted by mini-css-extract-plugin
export default {"circle":"euWwsz","rotate":"JRlCPb","clip":"NFXGUM","clip-reverse":"c3o_jF","clipReverse":"c3o_jF"};